<template>
    <div class="youtube__thumbnail-list">
        <div class="row">
            <div class="col-md-11 col-md-push-1">
                <div class="youtube__thumbnail-list__heading">
                    {{ texts.playlistHeading }}
                </div>
            </div>
        </div>

        <div
            v-for="video in videos"
            :key="video.id"
            class="row youtube__thumbnail-list__item"
        >
            <div class="col-xs-8 col-md-7 col-md-offset-1">
                <a
                    class="h6 hidden-md hidden-lg"
                    @click.prevent="playVideo(video)"
                    href="#"
                    >{{ video.title }}</a
                >
                <a
                    class="h6 hidden-xs hidden-sm"
                    @click.prevent="playVideo(video)"
                    href="#"
                    >{{ video.shortTitle }}</a
                >
                <div class="youtube-block__duration">
                    {{ video.duration }}
                </div>
            </div>

            <!-- Display thumbnail with a play icon -->
            <div class="col-xs-4">
                <div
                    class="youtube__thumbnail-container"
                    @click="playVideo(video)"
                >
                    <img
                        :src="video.thumbnailUrl"
                        alt="video.Title"
                        class="youtube__thumbnail--small"
                    />

                    <img class="play-icon" src="@/assets/icons/play_icon.svg" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'YoutubeVideoList',
    props: {
        videos: { type: Array },
        texts: { type: Object },
    },
    methods: {
        playVideo(video) {
            this.$emit('playVideo', video);
        },
    },
};
</script>
<style></style>
